import * as Sentry from '@sentry/browser';
import { ServerError } from '@apollo/client/link/utils';
import { ServerParseError } from '@apollo/client/link/http';

// Issues are fingerprinted on the error's name, so keep the name stable and put
// anything that varies per event (ids, urls, types) in extra or tags instead.
// Otherwise each distinct value becomes its own Sentry issue.
export const captureExceptionWithContext = ({
  error,
  extra,
  tags,
}: {
  error: Error | ServerError | ServerParseError;
  extra?: Record<string, unknown>;
  tags?: Record<string, string | number | boolean | undefined>;
}) => {
  Sentry.withScope((scope) => {
    scope.setFingerprint([
      error.name && error.name !== '' ? error.name : error.message,
    ]);
    if (extra) {
      scope.setExtras(extra);
    }
    if (tags) {
      scope.setTags(tags);
    }
    Sentry.captureException(error);
  });
};

const captureException = (error: Error | ServerError | ServerParseError) => {
  captureExceptionWithContext({ error });
};

export const addBreadCrumb = (breadcrumb: Sentry.Breadcrumb) => {
  Sentry.addBreadcrumb(breadcrumb);
};

export default captureException;
